'use strict';

import React from 'react';
import ClassNames from 'classnames';
import MediaActions from 'actions/MediaActions';
import ProductActions from 'actions/ProductActions';

import 'styles/Category.scss';

class CategoryComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: this.props.cid
    }
    this.onClick = this.onClick.bind(this);
  }
  onClick(cat) {
    let cid = cat._id;
    let type = this.props.type;
    if(cid === this.state.active) {
      // this.setState({active: null});
      // MediaActions.updateCategoryId(null);
    } else {
      this.setState({active: cid});
      if(type === 'feature'){
        ProductActions.updateFeatureId(cid);
      }else{
        MediaActions.updateCategoryId(cid);
      }

      if(this.props.onCategoryChange){
        this.props.onCategoryChange(cat)
      }
    }

    if(type !== 'feature'){
    // 更新 explore 页面分享标记
      MediaActions.updateShareTag();
    }
  }
  render() {
    let cats = this.props.category;
    let catItems = cats.map((cat) =>
      <div key={cat._id} onClick={this.onClick.bind(this, cat)} className="columns">
        <a className={this.state.active === cat._id ? 'button active' : 'button'}>{cat.name}</a>
      </div>
    );
    let componentClass = ClassNames({
      'category-component': true,
      'expanded': true,
      'fixed': this.props.fixed
    });
    let height = window.innerWidth > 600?'56px':'36px';
    let top = this.props.top;
    return (
      <div style={this.props.fixed?{'height':`${height}`}:{}}>
        <div className={componentClass} style={top?{'top': top}:{}} >
          <div className="category-wrap">
            <div className="columns" onClick={this.onClick.bind(this, {_id:null})}>
              <a className={this.state.active === null? 'button active' : 'button'}>全部</a>
            </div>
            {catItems}
          </div>
        </div>
      </div>
    );
  }
}

CategoryComponent.displayName = 'CategoryComponent';

// Uncomment properties you need
// CategoryComponent.propTypes = {};
// CategoryComponent.defaultProps = {};

export default CategoryComponent;



// WEBPACK FOOTER //
// ./src/components/CategoryComponent.js